import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { oTScheduleBloodDetails } from './oTScheduleBloodDetails';
import { oTscheduleChecklistDetails } from './oTscheduleChecklistDetails';
import { oTScheduleDrugsDetails } from './oTScheduleDrugsDetails';
import { oTscheduleEmployeeDetails } from './oTscheduleEmployeeDetails';
import { oTscheduleEqupimentDetails } from './oTscheduleequipmentDetails';
import { oTScheduleImplantDetails } from './oTScheduleImplantDetails';
import { oTScheduleNotesDetails } from './oTScheduleNotesDetails';
import { oTSchedulePhysicianDetails } from './oTSchedulePhysicianDetails';


export interface scheduleHeaderParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface scheduleHeader { 

    otScheduleId?:number;
    otBookingId:number;
    otsConfirmStartDateTime:any;
    otsConfirmEndDateTime:any;
    otsActualStartDateTime:any;
    otsActualEndDateTime:any;
    otsConfirmBy:string;
    otsConfirmDate:any;
    statusFlag:string;
    createdBy:string;
    createdDate:any;
    updatedDate:any;
    updatedBy:string;
    createdIP:string;
    updatedIP:string;
    branchId: string;
    tenantId: string;  
    regId:string;
    otsConfirmFlag:string;
    otsConfirmNotes:string;
   
    oTSchedulePhysicianMaster: oTSchedulePhysicianDetails[];
    oTScheduleEmployeeMaster:oTscheduleEmployeeDetails[];
    oTScheduleBloodDet:oTScheduleBloodDetails[];
    oTScheduleImplantDet:oTScheduleImplantDetails[];
    oTScheduleDrugsDet:oTScheduleDrugsDetails[];
    oTSchChecklistDet:oTscheduleChecklistDetails[];
    oTSchEquipmentDet:oTscheduleEqupimentDetails[];
    oTScheduleNotesDet:oTScheduleNotesDetails[];
    
    parameters?: scheduleHeaderParameter[];
    links?: any;
}


export abstract class scheduleHeaderData {
    abstract list(url: string): Observable<any>; 
    abstract getById(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract getall(url: string): Observable<scheduleHeader[]>;
    abstract create(url: string, data: any): Observable<any>;
    abstract update(url: string, data: scheduleHeader): Observable<scheduleHeader>;
    abstract delete(url: string): Observable<any>;
}
